import { render, staticRenderFns } from "./DonutChart85.vue?vue&type=template&id=4b4c6ba4&scoped=true&"
import script from "./DonutChart85.vue?vue&type=script&lang=js&"
export * from "./DonutChart85.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4c6ba4",
  null
  
)

export default component.exports